// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/containers/scss/autosetapp.scss
// module id = 382
// module chunks = 2